import React from "react";
import { Box, FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";

const TablePaginationControls = ({
  page,
  rowsPerPage,
  totalRecords,
  onPageChange,
  handlePerPageChange,
  rowsPerPageOptions = [10, 15, 25, 50, 100, 250],
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
      {/* Rows per page selector */}
      <Box display="flex" alignItems="center">
        {/* <Typography variant="body2">Records per page:</Typography> */}
        <Select value={rowsPerPage} onChange={handlePerPageChange} size="small" variant="outlined">
          {rowsPerPageOptions.map((size) => (
            <MenuItem key={size} value={size}>
              {size} / page
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* Pagination */}
      <Pagination
        color="primary"
        page={page}
        count={Math.ceil(totalRecords / rowsPerPage)}
        onChange={onPageChange}
        showFirstButton
        showLastButton
      />
    </Box>
  );
};

export default TablePaginationControls;
